import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CRMUC } from 'src/app/models/crm/crmuc';
import { Filtro } from 'src/app/models/filtro';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmucService } from 'src/app/services/crm/crmuc.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CadastrarUcComponent } from './cadastrar-uc/cadastrar-uc.component';

declare const $: any;

@Component({
  selector: 'app-uc',
  templateUrl: './uc.component.html',
  styleUrls: ['./uc.component.scss']
})
export class UcComponent implements OnInit {
  // variáveis
  idOportunidade;
  ucsFiltrados: CRMUC[] = [];
  carregando = true;
  campoOrdenacao = 'numero';
  ordenarDesc = false;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  filtroNome: Filtro = { Propriedade: 'numero', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginatorUC', { static: false }) paginator: MatPaginator;

  constructor(
    private ucService: CrmucService, private utilitarioService: UtilitarioService,
    private router: Router, private globalService: GlobalService, public dialog: MatDialog,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,
    public dialogRef: MatDialogRef<UcComponent>, @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.idOportunidade = Number(this.data.idOportunidade);
    this.buscarUCs();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarUCs();
    this.paginator.firstPage();
  }

  buscarUCs() {
    this.carregandoService.mostra('buscaUCs');
    this.carregando = true;

    this.ucService.consultarUCsComPaginacao(this.idOportunidade, this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
        this.ucsFiltrados = dados.itens;

        this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(dados.total);

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaUCs');
      }, (erro) => {
        this.carregandoService.esconde('buscaUCs');
        this.notificacaoService.erro(erro);
      });
  }

  novoUC() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarUcComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { idOportunidade: this.idOportunidade },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buscarUCs();
      }
    });
  }

  editarUC(uc: CRMUC) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarUcComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { id: uc.id, idOportunidade: this.idOportunidade },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buscarUCs();
      }
    });
  }

  excluirUC(uc: CRMUC) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Nº da Instalação Recebedora?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiUC');
        this.ucService.excluir(uc.id).subscribe(resp => {
          this.notificacaoService.sucesso('Nº da Instalação Recebedora excluído com sucesso!!!');
          this.carregandoService.esconde('excluiUC');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluiUC');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarUCs();
  }

  ngOnDestroy(): void {}

  fechar() {
    this.dialogRef.close();
  }
}